"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardRequirementsComponent_vue_1 = require("./CardRequirementsComponent.vue");
const CardDescription_vue_1 = require("./CardDescription.vue");
const CardRenderData_vue_1 = require("./CardRenderData.vue");
const Types_1 = require("@/common/cards/render/Types");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardContent',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        requirements: {
            type: Array,
            required: true,
        },
        isCorporation: {
            type: Boolean,
            required: true,
        },
        bottomPadding: {
            type: String,
        },
    },
    components: {
        CardRequirementsComponent: CardRequirementsComponent_vue_1.default,
        CardDescription: CardDescription_vue_1.default,
        CardRenderData: CardRenderData_vue_1.default,
    },
    methods: {},
    computed: {
        corporationClass() {
            return this.isCorporation ? 'card-content-corporation' : '';
        },
        hasDescription() {
            const description = this.metadata.description;
            return description !== undefined && (typeof (description) !== 'string' || description.length > 0);
        },
        firstRow() {
            if ((0, Types_1.isICardRenderRoot)(this.metadata.renderData) && this.metadata.renderData.rows.length > 0) {
                return {
                    is: 'root',
                    rows: [this.metadata.renderData.rows[0]],
                };
            }
            return undefined;
        },
        remainingRows() {
            if ((0, Types_1.isICardRenderRoot)(this.metadata.renderData) && this.metadata.renderData.rows.length > 1) {
                return {
                    is: 'root',
                    rows: this.metadata.renderData.rows.slice(1),
                };
            }
            return undefined;
        },
    },
});
